import React from 'react';
import { H3 } from '../../components/H3';

export const ShippingInfoPage = () => {
  return (
    <>
      <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center space-y-8 text-center">
        <H3 className="font-semibold">SHIPPING INFO</H3>
        <p className="">
          온라인 구매 시 평일 14시 이전에 결제 완료된 주문에 한해 당일
          출고됩니다. 총 구매금액이 10만원 미만일 경우 배송비 3,000원이 부과되며
          총 구매금액이 10만원 이상일 경우 무료로 배송이 됩니다.
          <br />
          <br /> 평일 14시 이전 결제 완료된 주문 건은 당일 출고되며 14시 이후
          주문 건의 경우 익일 오전 10시에 출고 작업이 시작됩니다. 14시 이후 주문
          건에 대해 주문 취소를 원하실 경우 익일 오전 10시 이전에 취소를
          부탁드립니다. 자세한 문의사항은 고객센터(02-541-0854)로 문의
          부탁드립니다.
        </p>
        <div className="text-12 flex flex-col space-y-6">
          <p className="flex flex-col ">
            <span className="font-bold"> 1. 배송사</span>
            우체국 택배(1588-1300) / 로젠 택배(1588-9988)
            <br />
            - 퀵 배송과 직접 방문 수령은 업체 사정에 의해 불가능합니다.
            <br />
            - 물류 센터 마다 출고 되는 배송 업체가 다르므로 배송 조회 시 필히 MY
            PAGE에서 배송 업체 및 송장 번호를 확인 부탁드립니다.
            <br />
          </p>

          <p className="flex flex-col ">
            <span className="font-bold"> 2. 배송조회</span>
            당일 출고된 상품의 경우 당일 저녁에 해당 택배사로 상품이 인계됩니다.
            <br />
            상품이 택배사로 전달되면 배송업체 시스템에 운송장번호가 등록되므로
            익일 오전부터 배송조회가 가능합니다.
          </p>

          <p className="flex flex-col ">
            <span className="font-bold"> 3. 배송기간</span>
            평일 14시 이전 결제완료된 주문건은 당일 출고되며 배송은 1~3일 정도
            소요됩니다.
            <br />
            - 상품준비 도중 시스템 오류나 제품상 문제로 상품의 발송이 늦어지거나
            품절이 될 수 있습니다.
            <br />
            - 휴일(주말/공휴일 포함) 주문건은 다음 영업일에 상품준비 후
            발송됩니다.
            <br />- 주문 상품이 ‘배송중’ 상태일 경우 ‘마이페이지 {`>`} 주문/배송
            내역 {`>`} 배송조회’ 에서 운송장 번호 조회가 가능합니다.
            <br />
          </p>
        </div>
      </div>
    </>
  );
};
